import { Injectable, isDevMode } from '@angular/core';

import { environment } from '@env/config.override';
import { AppEnvironment, AppInfo, IAppEnv } from '@models/app-info.model';

@Injectable({
  providedIn: 'root',
})
export class AppInfoService {
  appInfo: AppInfo;
  loadedEnvironment: IAppEnv;

  async fetchEnv(env?: AppEnvironment) {
    if (!isDevMode()) {
      this.appInfo = await fetch('/configurations/app-info.json').then((m) => m.json().then((data) => new AppInfo(data)));
    } else {
      this.appInfo = new AppInfo({ environment: env ? env : environment, version: 'dev' });
    }
    this.loadedEnvironment = this.appInfo.loadedEnvironment;
  }
}
